import { render, staticRenderFns } from "./FieldTipo.vue?vue&type=template&id=0e036153"
import script from "./FieldTipo.vue?vue&type=script&lang=js"
export * from "./FieldTipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports